export default __webpack_public_path__ + "static/media/ico_votacion.d304c478.svg";